export default __webpack_public_path__ + "static/media/default-pet-profile-image-placeholder.a73321c6.svg";